























import Vue from 'vue'
import { EmailInputElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'EmailInput',

  data: () => ({
    inputText: '',
    onFocus: false
  }),
  methods: {
    handleFocus (): void {
      this.onFocus = true
    }
  },
  mounted () {
    this.inputText = this.templateItemData.value ?? ''
  },
  props: {
    templateItemData: {
      type: Object as () => EmailInputElInterface,
      required: true
    }
  }
})
